import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const TemplateButtons = ({
	saveTemplate,
	saveTemplateAndExit,
	saveTemplateAndMakePayment,
	isLoading,
	saveTemplateButtonText,
	saveTemplateAndMakePaymentButtonText,
	saveTemplateAndExitButtonText,
	showTemplateButtons,
}) => (
	<div>
		{showTemplateButtons && (
			<Button
				isLoading={isLoading}
				id="button-save-template"
				display="secondary"
				onClick={saveTemplate}
				disabled={isLoading}
			>
				{saveTemplateButtonText}
			</Button>
		)}
		{showTemplateButtons && (
			<Button
				isLoading={isLoading}
				id="button-save-template-make-payment"
				display="secondary"
				onClick={saveTemplateAndMakePayment}
				disabled={isLoading}
			>
				{saveTemplateAndMakePaymentButtonText}
			</Button>
		)}
		<Button
			isLoading={isLoading}
			id="button-save-template-exit"
			display="primary"
			onClick={saveTemplateAndExit}
			disabled={isLoading}
		>
			{saveTemplateAndExitButtonText}
		</Button>
	</div>
);

TemplateButtons.propTypes = {
	saveTemplate: PropTypes.func.isRequired,
	saveTemplateAndExit: PropTypes.func.isRequired,
	saveTemplateAndMakePayment: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
	saveTemplateButtonText: PropTypes.string.isRequired,
	saveTemplateAndMakePaymentButtonText: PropTypes.string.isRequired,
	saveTemplateAndExitButtonText: PropTypes.string.isRequired,
	showTemplateButtons: PropTypes.bool.isRequired,
};

export default TemplateButtons;
